export default __webpack_public_path__ + "static/2-9a7ff9b381b8df78d7325616ee674a3e.png";